import { render, staticRenderFns } from "./IcoImage.vue?vue&type=template&id=27ff42d3"
import script from "./IcoImage.vue?vue&type=script&lang=js"
export * from "./IcoImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports